export default __webpack_public_path__ + "static/media/ProductsList_img3_En.ceb3beb9.webp";